import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const isJa = i18n.language === 'ja';

  const toggleLang = () => i18n.changeLanguage(isJa ? 'en' : 'ja');

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-festival sticky-top shadow-sm">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <span style={{ fontSize: '1.5rem' }}>🌏</span>
          <span className="fw-bold" style={{ letterSpacing: '.02em' }}>Glocal Festival</span>
        </Link>

        {/* Language switcher always visible on mobile, next to toggler */}
        <div className="d-flex align-items-center gap-2 d-lg-none">
          <button
            onClick={toggleLang}
            className="btn btn-sm btn-outline-light rounded-pill px-3"
            style={{ fontWeight: 600, letterSpacing: '.05em', fontSize: '.8rem' }}
          >
            {isJa ? '🇺🇸 EN' : '🇯🇵 JP'}
          </button>
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMain"
            aria-controls="navbarMain"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </div>

        <div className="collapse navbar-collapse" id="navbarMain">
          <ul className="navbar-nav ms-auto align-items-center gap-1">
            <li className="nav-item">
              <a className="nav-link" href="#about">{t('nav.about')}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#donate">{t('nav.donate')}</a>
            </li>
            {/* Language switcher in desktop menu (hidden on mobile, shown above) */}
            <li className="nav-item ms-2 d-none d-lg-block">
              <button
                onClick={toggleLang}
                className="btn btn-sm btn-outline-light rounded-pill px-3"
                style={{ fontWeight: 600, letterSpacing: '.05em' }}
              >
                {isJa ? '🇺🇸 EN' : '🇯🇵 JP'}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
